export const roomMenuTestIds = {
  trigger: 'room-menu-trigger',
  copyLinkButton: 'room-menu-copy-link-button',
  leaveRoomButton: 'room-menu-leave-room-button',
  videoToggle: 'room-menu-video-toggle',
  managedToggle: 'room-menu-managed-toggle',
  hostTermButton: 'room-menu-host-term-button',
  hostTermPicker: 'room-menu-host-term-picker',
  curatedToggle: 'room-menu-curated-toggle',
} as const

